import React from "react";
import { useNavigate } from "react-router-dom";

export function withNavigationHooks(Component: any) {
  return (props: any) => (<Component navigationHooks={useNavigate()} {...props}/>);
}
